import PageHeader from "../PageHeader";
import { ReactComponent as LearnerIcon } from "../../images/learnersimage/learnericon.svg";
import useStyles from "../../../styles";
import ReportHeader from "../../CustomComponent/ReportHeader";
import { Report2Api } from "../../../service/services";
import { decryptData } from "../../../crypto";
import Loader from "../../CustomComponent/Loader";
import { useState } from "react";
import ViewRankWiseReport from "./ViewRankWiseReport.js";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

function RankWiseReport() {
  const classes = useStyles();
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [selectedExam, setSelectedExam] = useState("");
  const [data, setData] = useState([]);
  const [column, setColumn] = useState([]);

  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  const Heading = [
    {
      id: 1,
      pageicon: <LearnerIcon />,
      mainheading: "Rank Wise Report",
    },
  ];

  const fetchData = async (selectedExam) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/export/result/view/${selectedExam}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      console.log("ritesh", response);

      if (response.data.success === false) {
        setLoaderOpen(false);
        toast.warning(response.message || "data not found");
        return;
      }

      setData(response.data.results);
      setColumn(response.data.columns);

    } catch (error) {
      console.error("Error fetching data: ", error);
       toast.warning(error.response.data.message || "data not found");
    }
  };

  return (
    <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
      <Loader loaderOpen={loaderOpen} />
      <PageHeader Heading={Heading} />
      <ReportHeader
        exportApi={Report2Api}
        fetchData={fetchData}
        setLoaderOpen={setLoaderOpen}
        setSelectedExam={setSelectedExam}
        selectedExam={selectedExam}
      />
      <ViewRankWiseReport
        selectedExam={selectedExam}
        cources={data}
        column={column}
      />
      <ToastContainer />
    </div>
  );
}
export default RankWiseReport;
